import { CopyButton } from "@/components/common/CopyButton"

export const JsonSection = ({ json }: { json: string }) => (
  <div className="flex h-full w-full flex-col gap-2 min-h-0 flex-1">
    <div className="flex items-center justify-between gap-3">
      <span className="text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">
        Machine Readable License
      </span>
      <CopyButton value={json} />
    </div>
    <div className="flex-1 min-h-0 w-full overflow-auto rounded-lg border border-slate-200/70 bg-slate-50/70 px-3 py-2 font-mono text-[11px] leading-relaxed text-slate-700">
      <pre className="whitespace-pre w-full min-w-full">{json}</pre>
    </div>
  </div>
)
